export default __webpack_public_path__ + "static/media/page-v5-3.5519f757.png";